// types of actions to be supported by products (ADS)

export const GET_ADVERTISEMENTS_LOADING = "advertisements/loading";
export const GET_ADVERTISEMENTS_SUCCESS = "advertisements/success";
export const GET_ADVERTISEMENTS_ERROR = "advertisements/error";
export const POST_ADVERTISEMENTS_LOADING = "post/advertisements/loading";
export const POST_ADVERTISEMENTS_SUCCESS = "post/advertisements/success";
export const POST_ADVERTISEMENTS_ERROR = "post/advertisements/error";
// Reset

export const RESET_ADVERTISEMENTS = "advertisements/reset";